export const GET_CARD_FEE = `/admin/card-fee`
